import { keepPreviousData, useMutation, useQuery, useQueryClient, useSuspenseQuery } from "@tanstack/react-query";
import { useParams } from "@tanstack/react-router";

import api from "api";
import { type ContentEdit } from "api/models/content";

export const useQueryContent = () => {
	const params = useParams({ from: "/content/$id" });
	return useSuspenseQuery({
		queryKey: ["content", params.id],
		queryFn: () => api.admin.content.get(Number(params.id))
	});
};

export const useQueryContents = (type: "all" | "featured" | undefined, search = "", page = 1) => {
	const take = 10;
	return useQuery({
		queryKey: ["contents", type, search, page],
		queryFn: () => api.admin.content.search({ featured: type === "featured" ? true : null, search, page, take }),
		placeholderData: keepPreviousData
	});
};

export const useMutateContent = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: ({ id, body}: { id: number, body: ContentEdit }) => api.admin.content.edit(id, body),
		onSuccess: (data, { id }) => {
			queryClient.setQueryData(["content", id.toString()], data);
			queryClient.invalidateQueries({ queryKey: ["contents"] });
		}
	});
};

export const useMutateFeatured = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: ({ id, value}: { id: number, value: boolean }) => api.admin.content.setFeatured(id, value),
		onSuccess: (data, { id }) => {
			queryClient.setQueryData(["content", id.toString()], data);
			queryClient.invalidateQueries({ queryKey: ["contents"] });
		}
	});
};